<script setup lang="ts">
import 'bootstrap-3-typeahead';

import $ from 'jquery';
import type { Ref } from 'vue';
import {
    computed,
    onBeforeUnmount,
    onMounted,
    shallowRef,
    unref,
} from 'vue';

import InputControl from './input-control.vue';

const props = defineProps<{
    id?: string;
    name?: string;
    value?: string | number;
    options?: Bootstrap3Typeahead.Options;
    source?: string[];
}>();

const inputRef = shallowRef<{ input: Ref<HTMLInputElement | undefined> } | undefined>();
const input = computed(() => unref(unref(inputRef)?.input));

onMounted(() => {
    const _input = unref(input);
    if(_input) {
        $(_input).typeahead({
            minLength: 0,
            showHintOnFocus: true,
            autoSelect: true,
            fitToElement: true,
            delay: 500,
            source: props.source,
            ...props.options,
        });
    }
});

onBeforeUnmount(() => {
    const _input = unref(input);
    if(_input) {
        $(_input).typeahead('destroy');
    }
});

</script>
<template>
    <InputControl
        :id="props.id"
        ref="inputRef"
        :name="props.name"
        :model-value="props.value"
        type="text"
        autocomplete="off"
    />
</template>
